import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormErrorMessage,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
  VStack,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { FaPen } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import {
  disableCoaches,
  getCoaches,
} from '../../../stores/slices/coaches/coachesActions';
import { getOrganisations } from '../../../stores/slices/organisations/organisationsActions';
import { filterByValue } from '../../../utils/filterByValue';
import DeleteAlert from '../../Alerts/DeleteAlert';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { securedAxiosInstance } from '../../../api/axios';
import CoachModal from './CoachModal';

const schema = yup
  .object({
    inviteEmail: yup
      .string()
      .email('Must be a valid email')
      .required('Email is required'),
  })
  .required();
const Coaches = () => {
  const dispatch = useDispatch();
  const [coaches, setCoaches] = useState([]);

  const [filteredCoaches, setFilteredCoaches] = useState([]);
  const [selectedCoaches, setSelectedCoaches] = useState([]);
  const [toUpdate, setToUpdate] = useState({ state: false, user: null });
  const [isDeleting, setIsDeleting] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const cancelRef = useRef();
  const searchRef = useRef();
  const inviteRef = useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenAlert,
    onOpen: onOpenAlertAlert,
    onClose: onCloseAlert,
  } = useDisclosure();
  const toast = useToast();
  const getCoachesData = async () => {
    const res = await dispatch(getCoaches());
    setCoaches(res.payload.data);

    setIsLoading(false);
  };
  useEffect(() => {
    setIsLoading(true);

    getCoachesData();
    dispatch(getOrganisations());
  }, []);
  useEffect(() => {
    setFilteredCoaches(coaches);
  }, [coaches]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const handleSelectAll = event => {
    let newSelectedCoaches;

    if (event.target.checked) {
      newSelectedCoaches = coaches.map(user => user.id);
    } else {
      newSelectedCoaches = [];
    }

    setSelectedCoaches(newSelectedCoaches);
  };
  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedCoaches.indexOf(id);
    let newSelectedCoaches = [];

    if (selectedIndex === -1) {
      newSelectedCoaches = newSelectedCoaches.concat(selectedCoaches, id);
    } else if (selectedIndex === 0) {
      newSelectedCoaches = newSelectedCoaches.concat(selectedCoaches.slice(1));
    } else if (selectedIndex === selectedCoaches.length - 1) {
      newSelectedCoaches = newSelectedCoaches.concat(
        selectedCoaches.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedCoaches = newSelectedCoaches.concat(
        selectedCoaches.slice(0, selectedIndex),
        selectedCoaches.slice(selectedIndex + 1)
      );
    }

    setSelectedCoaches(newSelectedCoaches);
  };
  const onCloseModal = () => {
    onClose();
    setToUpdate({ state: false, user: null });
  };
  const onDeleteItem = async () => {
    setIsDeleting(true);
    const res = await dispatch(disableCoaches({ selectedCoaches }));
    onCloseAlert();
    setIsDeleting(false);
    if (res.type === 'coaches/disableCoaches/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      await getCoachesData();
      setSelectedCoaches([]);
      toast({
        description: 'Coach has been disabled',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };

  const filter = data => {
    const text = data.target.value;
    setFilteredCoaches(filterByValue(coaches, text));
  };

  const clearInput = () => {
    searchRef.current.value = '';
    setFilteredCoaches(coaches);
  };
  const inviteCoach = async data => {
    const res = await securedAxiosInstance.post('/invite', {
      user: { email: data.inviteEmail },
    });
    console.log(res);
    if (res.status >= 200 && res.status < 400) {
      reset();
      toast({
        description: 'User has been invited',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    } else {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    }
  };
  return (
    <React.Fragment>
      <Box w={'full'} overflowX={'hidden'} overflowY={'auto'} mt={'2'}>
        <VStack spacing={'4'}>
          <Stack
            justifyContent={'space-between'}
            alignContent={'center'}
            direction={{ base: 'column', lg: 'row' }}
            w={'full'}
            spacing={4}
            pr={'2'}
            pb={'2'}
            zIndex={'10'}
            sx={{
              position: '-webkit-sticky',
              /* Safari */
              position: 'sticky',
              top: '0',
            }}
            bg={'white'}
            borderBottom={'1px'}
            borderColor={'gray.500'}
          >
            <InputGroup size="sm" maxW={{ base: '100%', lg: '40%' }}>
              <Input
                pr="4.5rem"
                placeholder="Search"
                borderRadius={'4'}
                onChange={filter}
                ref={searchRef}
              />
              <InputRightElement width="4.5rem" justifyContent={'end'}>
                <Button
                  size={'sm'}
                  borderLeftRadius={'none'}
                  onClick={clearInput}
                >
                  Clear
                </Button>
              </InputRightElement>
            </InputGroup>
            <HStack
              spacing={2}
              w={'full'}
              // maxW={{ base: '100%', lg: '40%' }}
              align={'start'}
              justify={'end'}
            >
              <Box>
                <form onSubmit={handleSubmit(inviteCoach)}>
                  <FormControl id="inviteEmail" isInvalid={errors.inviteEmail}>
                    <InputGroup size="sm">
                      <Input
                        pr="4.5rem"
                        placeholder="Invite Coaches by email"
                        borderRadius={'4'}
                        ref={inviteRef}
                        id="inviteEmail"
                        {...register('inviteEmail')}
                      />
                      <InputRightElement width="4.5rem" justifyContent={'end'}>
                        <Button
                          size={'sm'}
                          borderLeftRadius={'none'}
                          isLoading={isSubmitting}
                          type="submit"
                        >
                          Invite
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                    <FormErrorMessage>
                      {errors.inviteEmail && errors.inviteEmail.message}
                    </FormErrorMessage>
                  </FormControl>
                </form>
              </Box>
              <Button size={'sm'} onClick={onOpen}>
                Add Coach
              </Button>
              <Button
                size={'sm'}
                disabled={selectedCoaches.length <= 0}
                bg={'red.400'}
                _hover={{
                  color: 'red.400',
                  bg: 'transparent',
                }}
                onClick={onOpenAlertAlert}
              >
                Disable selected coaches
              </Button>
            </HStack>
          </Stack>
          <Box overflowX={'auto'} w={'full'}>
            <TableContainer>
              <Table
                variant="striped"
                colorScheme="gray"
                display={{
                  base: 'block',
                  md: 'table',
                }}
              >
                <Thead>
                  <Tr>
                    <Th>
                      <Checkbox
                        value="true"
                        onChange={handleSelectAll}
                        isChecked={selectedCoaches.length === coaches.length}
                      />
                    </Th>
                    <Th>Name</Th>
                    <Th>Email</Th>
                    <Th>Status</Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {coaches &&
                    (isLoading ? (
                      <Tr>
                        <Td colSpan={'5'}>
                          <Spinner color="primary" />
                        </Td>
                      </Tr>
                    ) : coaches.length > 0 ? (
                      filteredCoaches.map(user => (
                        <Tr key={user.id}>
                          <Td>
                            <Checkbox
                              value="true"
                              isChecked={
                                selectedCoaches.indexOf(user.id) !== -1
                              }
                              onChange={event =>
                                handleSelectOne(event, user.id)
                              }
                            />
                          </Td>
                          <Td>{user.full_name}</Td>
                          <Td>{user.email}</Td>
                          <Td color={user.is_active ? 'primary' : 'red.400'}>
                            {user.is_active ? 'Active' : 'Inactive'}
                          </Td>
                          <Td align={'right'} textAlign={'right'}>
                            <HStack justify={'end'}>
                              <IconButton
                                icon={<FaPen />}
                                size={'sm'}
                                onClick={() => {
                                  setToUpdate({
                                    state: true,
                                    user,
                                  });
                                  onOpen();
                                }}
                              />
                            </HStack>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={'5'}>No coaches found</Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </VStack>
      </Box>
      <DeleteAlert
        isOpen={isOpenAlert}
        cancelRef={cancelRef}
        onClose={onCloseAlert}
        isDeleting={isDeleting}
        header={`Disable Coach${selectedCoaches.length > 1 ? 'es' : ''}`}
        body={
          'Are you sure? If you disable this Coach, they will not be able to access their account until it is re-enabled.'
        }
        onDeleteItem={onDeleteItem}
        deleteText={'Disable'}
      />
      {isOpen && (
        <CoachModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onCloseModal}
          toUpdate={toUpdate}
          getCoaches={getCoachesData}
        />
      )}
    </React.Fragment>
  );
};

export default Coaches;
